import React from 'react';
import Widget from '../Widget';
import { Row, Col, Button } from 'react-bootstrap';
import NoData from '../NoData';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaInfoCircle } from 'react-icons/fa';

export default function SizeSettingHighestDegreeAwardedBanner({ institutionData }) {

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            <div className='text-start'>Generally, doctorate reflects institutions that awarded at least 20 doctorates. Master’s degree is displayed for institutions that awarded at least 50 master’s degrees. Please see the technical documentation for more.</div>
        </Tooltip>
    );

    if (!institutionData.post_meta.enrollment_2025.value) {
        return <NoData widgetTitle={'Size, Campus Setting, Highest Degree Awarded'} />;
    }

    const iconPath = '/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/widgets/instituional-classification/';

    let highestDegreeIcon = iconPath + 'degree.svg';

    // set school size icon
    let sizeIcon = iconPath + 'small.svg';
    if (['4', '5'].indexOf(institutionData.post_meta.ic2025size.value) > -1) {
        sizeIcon = sizeIcon.replace('small.svg', 'large.svg');
    } else if (institutionData.post_meta.ic2025size.value == '3') {
        sizeIcon = sizeIcon.replace('small.svg', 'medium.svg');
    }

    // set campus setting icon
    let settingIcon = iconPath + 'campus-setting1-2-3.svg';
    switch (institutionData.post_meta.setting2025.value) {
        case '4':
            settingIcon = settingIcon.replace('campus-setting-1-2-3.svg', 'campus-setting4.svg');
            break;
        case '5':
            settingIcon = settingIcon.replace('campus-setting-1-2-3.svg', 'campus-setting5.svg');
            break;
        case '6':
        case '7':
            settingIcon = settingIcon.replace('campus-setting-1-2-3.svg', 'campus-setting-6-7.svg');
            break;
        case '8':
            settingIcon = settingIcon.replace('campus-setting-1-2-3.svg', 'campus-setting8.svg');
            break;
        case '9':
            settingIcon = settingIcon.replace('campus-setting-1-2-3.svg', 'campus-setting9.svg');
            break;
        default:
            break;
    }

    return (
        <Widget className="size-setting-highest-degree-awarded-banner">
            <div className="row">
                <Row>
                    <Col xs={12} md={4} className="pb-4 pb-md-0">
                        <h4 className='widgetTitle'>Size</h4>
                        <div className="d-flex align-items-center">
                            <img src={sizeIcon} alt="School Size Icon" className='me-3' width="36" height="36" />
                            <p className="mb-1">{`${institutionData.post_meta.ic2025size.label} (${institutionData.post_meta.enrollment_2025.value?.toLocaleString()} students)`}</p>
                        </div>
                    </Col>
                    <Col xs={12} md={4} className="pb-4 pb-md-0">
                        <div className="divider-start ps-0 ps-md-4">
                            <h4 className='widgetTitle'>Campus Setting</h4>
                            <div className="d-flex align-items-center">
                                <img src={settingIcon} alt="Campus Setting Icon" className='me-3' width="48" height="39" />
                                <p className="mb-1">{institutionData.post_meta.setting2025.label}</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="divider-start ps-0 ps-md-4">
                            <h4 className='widgetTitle'>Highest Degree Awarded</h4>
                            <div className="d-flex align-items-center" id="highestDegree">
                                <img src={highestDegreeIcon}
                                    alt="Highest Degree Awarded" className='me-3' width="41" height="36" />
                                <p className="mb-1">{institutionData.post_meta.highest_degree_2025.label}</p>
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={renderTooltip}
                                >
                                    <Button variant="link"><FaInfoCircle /></Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Widget>
    );
}
